if (!customElements.get('cafe-postcards')) {
  customElements.define(
    'cafe-postcards',
    class CafePostcards extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-fe-cafe-track]');
        this.previousButton = this.querySelector('[data-fe-cafe-prev]');
        this.nextButton = this.querySelector('[data-fe-cafe-next]');

        if (!this.track || !this.previousButton || !this.nextButton) return;

        this.previousButton.addEventListener('click', () => this.scrollByCard(-1));
        this.nextButton.addEventListener('click', () => this.scrollByCard(1));
        this.track.addEventListener('scroll', () => this.updateControls(), { passive: true });
        window.addEventListener('resize', () => this.updateControls());
        this.updateControls();
      }

      scrollByCard(direction) {
        const firstCard = this.track.querySelector('.fe-cafe-card');
        const gap = parseFloat(getComputedStyle(this.track).columnGap || 0);
        const amount = firstCard ? firstCard.getBoundingClientRect().width + gap : this.track.clientWidth * 0.8;
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.track.scrollBy({
          left: amount * direction,
          behavior: prefersReducedMotion ? 'auto' : 'smooth',
        });
      }

      updateControls() {
        const maxScroll = this.track.scrollWidth - this.track.clientWidth - 2;
        this.previousButton.disabled = this.track.scrollLeft <= 2;
        this.nextButton.disabled = this.track.scrollLeft >= maxScroll;
      }
    }
  );
}
